import { ErrorHandler, Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { RumInitializerService } from '../services/rum/rum-initializer.service';

@Injectable()
export class RumErrorHandler implements ErrorHandler {
  private rumService = inject(RumInitializerService);

  handleError(error: unknown): void {
    if (!environment.rum?.applicationId) {
      console.error('[RumErrorHandler]', error);
    }
    this.rumService.recordError(error);
  }
}
